import React from 'react';
import Hero from '../components/sections/Hero';
import DomainSearch from '../components/sections/DomainSearch';
import FeaturedProject from '../components/sections/FeaturedProject';
import Partners from '../components/sections/Partners';
import About from '../components/sections/About';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import Services from '../components/sections/Services';
import Portfolio from '../components/sections/Portfolio';
import Testimonials from '../components/sections/Testimonials';
import Contact from '../components/sections/Contact';
import FloatingActionMenu from '../components/ui/FloatingActionMenu';

const Home = ({ theme, onToggleTheme }) => {
  return (
    <main>
      <Hero theme={theme} onToggleTheme={onToggleTheme} />
      <DomainSearch />
      <FeaturedProject />
      <Partners />
      <About />
      <WhyChooseUs />
      <Services />
      <Portfolio />
      <Testimonials />
      <Contact />
      <FloatingActionMenu />
    </main>
  );
};

export default Home;
